export const CAT = [
  {
    id: "01",
    name: "Quality Management",
  },
  {
    id: "02",
    name: "Clinical Operation",
  },
  {
    id: "03",
    name: "Data Management",
  },
  {
    id: "04",
    name: "Statistical Analysis",
  },
  {
    id: "05",
    name: "Medical Writing",
  },
  {
    id: "06",
    name: "System Management",
  },
  {
    id: "07",
    name: "Business Development",
  },
  { id: "08", name: "Regulatory Affairs" },
];

export const TYPE = [
  {
    id: 1,
    name: "Procedure",
  },
  {
    id: 2,
    name: "Form",
  },
  {
    id: 3,
    name: "Template",
  },
  {
    id: 4,
    name: "Work Instruction",
  },
];

export const CAT_FILTER = [
  {
    text: "Business Development",
    value: ["cat", "=", "07"],
  },
  {
    text: "Clinical Operation",
    value: ["cat", "=", "02"],
  },
  {
    text: "Data Management",
    value: ["cat", "=", "03"],
  },
  {
    text: "Medical Writing",
    value: ["cat", "=", "05"],
  },
  {
    text: "Quality Management",
    value: ["cat", "=", "01"],
  },
  {
    text: "Statistical Analysis",
    value: ["cat", "=", "04"],
  },
  {
    text: "System Management",
    value: ["cat", "=", "06"],
  },
  {
    text: "Regulatory Affairs",
    value: ["cat", "=", "08"],
  },
];

export const TYPE_FILTER = [
  {
    text: "Form",
    value: ["type", "=", 2],
  },
  {
    text: "Procedure",
    value: ["type", "=", 1],
  },
  {
    text: "Template",
    value: ["type", "=", 3],
  },
  {
    text: "Work Instruction",
    value: ["type", "=", 4],
  },
];
